import { FormattedDate } from 'react-intl';

import { CancelledPlan } from '../Dashboard.types';
import styles from './CancelledView.module.css';

export const CancelledView = ({ plan }: { plan: CancelledPlan }) => {
    return (
        <div className={styles.cancelledPaymentInfo}>
            This order was cancelled on{' '}
            <FormattedDate
                day="numeric"
                month="short"
                year="numeric"
                value={new Date(plan.cancelled_at)}
            />
            . No payment schedule was started and no payment has been taken.
            <p>
                If you have questions about this order, please contact your
                supplier.
            </p>
        </div>
    );
};
